interface StepperItemProps {
  stepNumber: number;
  stepName: string;
  isCurrentStep: boolean;
  isCompleted: boolean;
  onClick: () => void;
  isLastStep: boolean;
}

export const StepperItem = ({
  stepNumber,
  stepName,
  isCurrentStep,
  isCompleted,
  onClick,
  isLastStep,
}: StepperItemProps) => (
  <>
    <div
      className="flex flex-col items-center text-center cursor-pointer"
      onClick={onClick}
    >
      {/* border-2 border-blue-500 */}
      <div
        className={`relative px-4 w-fit flex flex-col gap-3 items-center justify-center h-10 rounded-full text-sm font-medium ${
          isCompleted ? " text-blue-500" : "border-gray-300 text-gray-500"
        }`}
      >
        <span
          className={`text-sm ${isCurrentStep && "text-blue-500 font-medium"}`}
        >
          {stepName}
        </span>
        <span
          className={`h-5 p-3 w-5 rounded-full flex justify-center items-center border-2 ${
            isCurrentStep && "text-blue-500 border-blue-500 "
          } ${isCompleted && "text-white bg-blue-500 "}`}
        >
          {stepNumber}
        </span>
      </div>
      {!isLastStep && (
        <div
          className={`border  w-20 relative left-16 bottom-1 ${
            isCompleted ? "border-blue-500" : "border-gray-300"
          }`}
        />
      )}
    </div>
  </>
);
